import { Injectable, OnInit } from '@angular/core';
import { AuthenticationService, User } from '../auth/authentication.service';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, of, switchMap } from 'rxjs';
import { NavItem } from '../../../core/models/nav-item.model';

@Injectable({
  providedIn: 'root',
})
export class LayoutService {
  private readonly ADMIN_MENU_ROUTE = '/navigation/admin.menu.json';
  private readonly USER_MENU_ROUTE = '/navigation/user.menu.json';
  private menu$: BehaviorSubject<NavItem[]> = new BehaviorSubject<NavItem[]>(
    [],
  );

  constructor(
    private authenticationService: AuthenticationService,
    private httpClient: HttpClient,
  ) {
    this.loadMenuBasedOnAccountType();
  }

  get menu(): Observable<NavItem[]> {
    return this.menu$.asObservable();
  }

  private loadMenuBasedOnAccountType() {
    this.authenticationService.user$
      .pipe(
        switchMap((user: Partial<User> | null) => {
          if (!user) return of(null);
          const accountType = user.accountType;
          switch (accountType) {
            case 'ADMIN':
              return this.httpClient.get<NavItem[]>(this.ADMIN_MENU_ROUTE);
            default:
              return this.httpClient.get<NavItem[]>(this.USER_MENU_ROUTE);
          }
        }),
      )
      .subscribe({
        next: (menu) => {
          this.menu$.next(menu ?? []);
        },
      });
  }

  getStatusColor(status?: string): { [key: string]: string } {
    const value = {
      color: '',
    };

    switch (status) {
      case 'PENDING':
      case 'IN-REVIEW':
        value.color = '#AC840C';
        break;
      case 'ACTIVE':
      case 'APPROVED':
      case 'COMPLETED':
      case 'PAID':
        value.color = '#008000';
        break;
      case 'INACTIVE':
      case 'QUERIED':
      case 'REJECTED':
        value.color = '#FF0000';
        break;
      case 'SCHEDULED':
        value.color = '#9F9F9F';
        break;
      case 'INSPECTED':
        value.color = '#BA12E8';
        break;
      default:
        value.color = 'var(--color-text)';
        break;
    }

    return value;
  }

  getStatusPillColor(status?: string): { [key: string]: string } {
    const value = {
      color: '',
      backgroundColor: '',
    };

    switch (status) {
      case 'IN-REVIEW':
      case 'PENDING':
        value.color = '#AC840C';
        value.backgroundColor = '#D8A40C33';
        break;
      case 'ACTIVE':
      case 'APPROVED':
      case 'COMPLETED':
      case 'PAID':
        value.color = '#22543D';
        value.backgroundColor = '#C6F6D5';
        break;
      case 'INACTIVE':
      case 'QUERIED':
      case 'QUERY':
      case 'REJECTED':
        value.color = '#FF0000';
        value.backgroundColor = '#D700041A';
        break;
      case 'SCHEDULED':
        value.color = '#9F9F9F';
        value.backgroundColor = '#ECECEC';
        break;
      case 'INSPECTED':
        value.color = '#BA12E8';
        value.backgroundColor = '#B649FF1A';
        break;
      default:
        value.color = 'var(--color-bg-primary)';
        value.color = '#E7E7FF';
        break;
    }

    return value;
  }
}
